import {
  getSurveyors
} from "@/api/surveyors";
import {
  Message
} from 'element-ui'
export default {
  state: {
    surveyors: [],
    selected: []
  },
  mutations: {
    SET_SELECTED(state, data) {
      state.selected = data
    },
    SET_SURVEYORS(state, data) {
      state.surveyors = data
    }
  },
  actions: {
    getSurveyors({
      commit
    }, ) {
      getSurveyors()
        .then((res) => {
          const surveyors = res.data;
          // this.surveyors = surveyors.map((surveyor) => ({
          //   key: surveyor.id,
          //   name: surveyor.name,
          //   mobile: surveyor.mobile,
          // }));
          // this.setSurveyors(this.surveyors);
          commit("SET_SURVEYORS", surveyors)
        })
        .catch(() => {
          Message({
            type: "error",
            center: true,
            message: "请求失败",
            duration: 1500,
          });
        });
    },
  },
  getters: {
    surveyors: state => {
      return state.surveyors
    }
  }
}